import { useState } from "react";
import { IoClose } from "react-icons/io5";

import TableControls from "../../../components/common/TableControls";
import TableSize from "../../../components/common/TableSize";
import TextboxSearch from "../../../components/common/TextboxSearch";
import Modal from "../../../components/common/Modal";
import AccountRDOFilter from "./AccountRDOFilter";

import accountService from "../../../services/accountService";

const AccountRDOHeader = ({ options, onChange }) => {
  const [showFilter, setShowFilter] = useState(false);

  const statuses = accountService.getAccountStatuses();

  const settings = [
    {
      id: 1,
      content: (
        <TableSize size={options.size} onChange={(e) => handleSizeChange(e)} />
      ),
    },
  ];

  const handleSizeChange = (event) => {
    const size = event.target.value;

    if (size !== options.size) {
      const new_options = { ...options };
      new_options.size = size;
      new_options.current_page = 1;
      onChange(new_options);
    }
  };

  const handleSearch = (query) => {
    const new_options = { ...options };

    if (new_options.search_query !== query) {
      new_options.status = "";
      new_options.rdo = "";
      new_options.search_query = query;
      new_options.current_page = 1;
      onChange(new_options);
    }
  };

  const handleFilter = (status, rdo) => {
    const new_options = { ...options };
    new_options.status = status;
    new_options.rdo = rdo;
    onChange(new_options);
    setShowFilter(false);
  };

  const handleRemoveFilter = (item) => {
    const new_options = { ...options };

    if (item === 1) new_options["status"] = "";
    if (item === 2) new_options["rdo"] = "";

    onChange(new_options);
  };

  const renderStatus = (status) => {
    const selected_status = statuses.filter((i) => i.value === status);
    return selected_status[0].label;
  };

  return (
    <>
      <div className="block lg:flex justify-between items-center">
        <div>
          <p className="text-gray-500">Account RDO</p>
          <span className="text-gray-400 text-sm">
            Accounts with their respective RDOs
          </span>
        </div>
        <div className="mt-5 lg:mt-0 block md:flex md:space-x-2">
          <TextboxSearch placeholder="Search..." onSearch={handleSearch} />
          <TableControls
            onFilter={() => setShowFilter(true)}
            settings={settings}
          />
        </div>
      </div>
      <div className="mt float-right">
        <div className="flex gap-2">
          {options.status !== "" && (
            <div className="py-1 px-2 flex items-center rounded bg-gray-100 text-gray-500 text-xs">
              Status: {renderStatus(options.status)}
              <IoClose
                className="ml-2 cursor-pointer hover:text-red-500"
                onClick={() => handleRemoveFilter(1)}
              />
            </div>
          )}
          {options.rdo && (
            <div className="py-1 px-2 flex items-center rounded bg-gray-100 text-gray-500 text-xs">
              RDO: {options.rdo}
              <IoClose
                className="ml-2 cursor-pointer hover:text-red-500"
                onClick={() => handleRemoveFilter(2)}
              />
            </div>
          )}
        </div>
      </div>
      <Modal
        borderTop
        title="Filter"
        isOpen={showFilter}
        onClose={() => setShowFilter(false)}
        children={
          <AccountRDOFilter options={options} onFilter={handleFilter} />
        }
      />
    </>
  );
};

export default AccountRDOHeader;
